import React from 'react';
import styles from './extra-promo-offer.module.scss';
import Image from 'next/image';
import { ActionLink } from '~/gql/__generated__/types';
import Link from 'next/link';

interface Props {
  title: string;
  subtitle: string;
  priceHighlight?: string;
  imageSrc?: string;
  className?: string;
  learnMoreLink?: ActionLink | null;
}

const ExtraPromoOffer: React.FC<Props> = ({
  title,
  subtitle,
  imageSrc,
  className,
  learnMoreLink,
}) => {
  return (
    <div className={`${styles.container} ${className}`}>
      {imageSrc && (
        <Image
          src={imageSrc}
          alt=""
          className={styles.cardImage}
          width={88}
          height={56}
        />
      )}
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        <div
          className={styles.subtitle}
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
        {learnMoreLink?.linkUrl && (
          <Link
            className={styles.buttonLink}
            href={learnMoreLink?.linkUrl || ''}
            target={learnMoreLink?.openInNewTab ? '_blank' : '_self'}
            rel="noopener noreferrer"
          >
            {learnMoreLink?.ariaLabel}
          </Link>
        )}
      </div>
    </div>
  );
};

export default ExtraPromoOffer;
